import React from 'react';
import { StarIcon } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const testimonials = [{
  quote: 'Comecei sem saber nada e hoje já tenho minha própria marca de velas. O ebook mudou minha vida e me deu a independência que eu buscava!',
  name: 'Ana Clara',
  role: 'Empreendedora',
  color: 'bg-brand-rose',
  initials: 'AC'
}, {
  quote: 'O passo a passo é incrível! Consegui fazer minhas primeiras velas na primeira semana. Muito didático e as dicas de fornecedores valem ouro.',
  name: 'Mariana Santos',
  role: 'Artesã',
  color: 'bg-brand-gold',
  initials: 'MS'
}, {
  quote: 'Melhor investimento que fiz. O conteúdo sobre finanças e precificação me ajudou muito a organizar meu negócio e finalmente ver lucro real.',
  name: 'Juliana Costa',
  role: 'Empresária',
  color: 'bg-brand-brown',
  initials: 'JC'
}];
export function Testimonials() {
  return <section id="depoimentos" className="py-24 lg:py-32 bg-white" data-id="element-227">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-228">
        <FadeIn className="text-center mb-16" data-id="element-229">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-brand-brown" data-id="element-230">
            Histórias de quem já transformou sua vida
          </h2>
          <p className="mt-4 text-brand-brown/70 text-lg max-w-2xl mx-auto" data-id="element-231">
            Junte-se a milhares de mulheres que já estão faturando com suas
            próprias marcas.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-232">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.15} className="h-full" data-id="element-233">
              <div className="bg-brand-cream p-8 rounded-3xl h-full flex flex-col relative border-l-4 border-brand-gold shadow-sm hover:shadow-md transition-shadow" data-id="element-234">
                <div className="flex items-center gap-4 mb-6" data-id="element-235">
                  <div className={`w-12 h-12 rounded-full ${testimonial.color} flex items-center justify-center text-white font-serif font-bold text-lg shadow-sm`} data-id="element-236">
                    {testimonial.initials}
                  </div>
                  <div className="flex gap-1" data-id="element-237">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-238" />)}
                  </div>
                </div>

                <p className="text-brand-brown/80 text-lg mb-8 flex-grow italic leading-relaxed" data-id="element-239">
                  "{testimonial.quote}"
                </p>

                <div className="mt-auto border-t border-brand-blush pt-4" data-id="element-240">
                  <p className="font-bold text-brand-brown font-serif text-lg" data-id="element-241">
                    {testimonial.name}
                  </p>
                  <p className="text-brand-rose text-sm font-medium" data-id="element-242">
                    {testimonial.role}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}